export interface TawkToConfig {
  enabled: boolean
  propertyId: string
  widgetId: string
}

declare global {
  interface Window {
    Tawk_API?: Record<string, unknown> & {
      hideWidget?: () => void
      showWidget?: () => void
      shutdown?: () => void
    }
    Tawk_LoadStart?: Date
  }
}

const SCRIPT_ID = 'cdt-tawk-to-script'

export function parseTawkToConfig(raw?: string | null): TawkToConfig {
  if (!raw?.trim()) {
    return { enabled: false, propertyId: '', widgetId: '' }
  }

  try {
    const parsed = JSON.parse(raw) as Partial<TawkToConfig>
    const propertyId = String(parsed.propertyId ?? '').trim()
    const widgetId = String(parsed.widgetId ?? '').trim()
    return {
      enabled: parsed.enabled === true && Boolean(propertyId) && Boolean(widgetId),
      propertyId,
      widgetId,
    }
  } catch {
    return { enabled: false, propertyId: '', widgetId: '' }
  }
}

export function isTawkToInitialized(): boolean {
  return Boolean(typeof document !== 'undefined' && document.getElementById(SCRIPT_ID))
}

export function initTawkTo(config: TawkToConfig): boolean {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false
  if (!config.enabled || !config.propertyId || !config.widgetId) return false
  if (isTawkToInitialized()) return true

  window.Tawk_API = window.Tawk_API || {}
  window.Tawk_LoadStart = new Date()

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.async = true
  script.charset = 'UTF-8'
  script.setAttribute('crossorigin', '*')
  script.src = `https://embed.tawk.to/${encodeURIComponent(config.propertyId)}/${encodeURIComponent(config.widgetId)}`

  const first = document.getElementsByTagName('script')[0]
  if (first?.parentNode) {
    first.parentNode.insertBefore(script, first)
  } else {
    document.head.appendChild(script)
  }

  return true
}

export function hideTawkTo(): void {
  try {
    window.Tawk_API?.hideWidget?.()
  } catch {
    // ignore
  }
}

export function showTawkTo(): void {
  try {
    window.Tawk_API?.showWidget?.()
  } catch {
    // ignore
  }
}
